export default __webpack_public_path__ + "static/media/img-avatar-2.fb09158a.jpg";